module.exports = __webpack_public_path__ + "static/media/history.82650fbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/guide/history.svg
// module id = 593
// module chunks = 0